import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const ExternalBlogArticlesQuery = gql`
  query ($tags: [String!]) {
    externalBlogArticles(blogTags: $tags)
  }
`;

interface IInputProps {
  children?: any;
  tags: string[];
}

interface IResponse {
  data: any;
}

class GetExternalBlogArticlesQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const { blogArticles }: any = this.props;
    return this.props.children({
      blogArticles
    });
  }
}

export default compose(
  graphql<IInputProps, Response>(ExternalBlogArticlesQuery, {
    name: 'blogArticles',
    options: props => ({
      variables: {
        tags: props.tags,
      }
    })
  })
)(GetExternalBlogArticlesQuery);


// WEBPACK FOOTER //
// ./src/components/Query/ExternalBlogArticles/ExternalBlogArticles.ts